import React from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import AccountsPage from './AccountsPage';
import { ClientCompanies } from './ClientCompanies';
import { isExternalUser } from '@/components/main/shell/userKind';

/**
 * Home-route fork. External (client) users see the "Welcome back" company
 * picker; internal/staff users (and the not-yet-loaded /me state, via
 * default-deny) see the existing Accounts page. Same seam pattern as
 * DashboardSwitch.
 */
const AccountsHome = (props: RouteComponentProps) => {
  const me = useSelector((s: any) => s.me);
  const data = useSelector((s: any) => s.loggedUser?.data) || {};
  const external = isExternalUser(me);

  if (external) {
    const clientName =
      `${data.firstName || ''} ${data.lastName || ''}`.trim() ||
      data.emailAddress ||
      '';
    return (
      <ClientCompanies
        clientName={clientName}
        onOpen={(id) => props.history.push(`/projects/${id}`)}
      />
    );
  }
  return <AccountsPage />;
};

export default AccountsHome;
